/**
 * Storage utility functions for local data persistence
 * Provides a simple API to save and retrieve data from localStorage
 */

// Storage keys
const STORAGE_KEYS = {
  TRANSACTIONS: 'finstack_transactions',
  GL_ACCOUNTS: 'finstack_gl_accounts',
  ACCOUNTS: 'finstack_accounts',
  CATEGORIES: 'finstack_categories',
  SETTINGS: 'finstack_settings',
  ENABLED_CURRENCIES: 'finstack_enabled_currencies'
};

/**
 * Save data to localStorage
 * @param key Storage key
 * @param data Data to save
 */
export const saveToStorage = <T>(key: string, data: T): void => {
  try {
    const serializedData = JSON.stringify(data);
    localStorage.setItem(key, serializedData);
    console.log(`Saved data to ${key}`, data);
  } catch (error) {
    console.error(`Error saving data to ${key}:`, error);
  }
};

/**
 * Load data from localStorage
 * @param key Storage key
 * @param defaultValue Default value to return if no data is found
 * @returns Retrieved data or default value
 */
export const loadFromStorage = <T>(key: string, defaultValue: T): T => {
  try {
    const serializedData = localStorage.getItem(key);
    if (serializedData === null) {
      return defaultValue;
    }
    return JSON.parse(serializedData) as T;
  } catch (error) {
    console.error(`Error loading data from ${key}:`, error);
    return defaultValue;
  }
};


// Export storage keys for use in other modules
export { STORAGE_KEYS };
